export interface ArticleBlock {
  heading: string;
  paragraphs: string[];
}

export interface Article {
  slug: string;
  title: string;
  category: string;
  excerpt: string;
  cover: string;
  tags: string[];
  author: string;
  date: string;
  readTime: string;
  views: string;
  featured?: boolean;
  content: ArticleBlock[];
}

export const articles: Article[] = [
  {
    slug: "douman-sukan-2026",
    title: "《都市觉醒者》速看：普通上班族一夜觉醒超能力",
    category: "sukan",
    excerpt: "三分钟带你搞懂这部都市异能神作的完整剧情脉络，从一个加班的社畜到守护城市的力量，高能反转不容错过。",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20manga%20illustration%20of%20a%20young%20office%20worker%20awakening%20glowing%20supernatural%20powers%20on%20a%20neon%20city%20rooftop%20at%20dusk%2C%20dramatic%20energy%20swirls%20in%20warm%20orange%20and%20gold%20tones%2C%20dynamic%20cinematic%20composition%2C%20detailed%20modern%20anime%20art%20style%2C%20warm%20lighting&width=900&height=600&seq=dm-sukan-01&orientation=landscape",
    tags: ["都市异能", "速看", "高能反转"],
    author: "抖漫编辑部",
    date: "2026-08-12",
    readTime: "3分钟",
    views: "12.6万",
    featured: true,
    content: [
      {
        heading: "故事开篇：平凡人的不平凡一夜",
        paragraphs: [
          "主角林澈是一名在都市里朝九晚九的普通上班族，每天被房贷、工作群和未读消息追着跑。然而一场罕见的城市流星雨，彻底改变了他的人生轨迹。",
          "在目睹一枚坠落的能量碎片后，林澈发现自己竟能操控周围的金属与磁场，成为这座城市里第一批觉醒超能力的普通人。",
        ],
      },
      {
        heading: "觉醒者的世界：并非只有力量",
        paragraphs: [
          "当超能力不再只是超级英雄的故事，当普通人也开始拥有力量，城市里的秩序正在悄然改写。政府机构、地下组织、还有同样觉醒的陌生人，都开始盯上林澈。",
          "他必须在保护家人与拥抱力量之间做出选择，而这场觉醒的背后，还藏着一个关乎整座城市的巨大秘密。",
        ],
      },
      {
        heading: "高能看点：三分钟上头的理由",
        paragraphs: [
          "本作最打动人的地方在于把「普通人获得力量」讲得真实又热血，每一话结尾都留有悬念，非常适合碎片时间一口气刷完。",
          "如果你喜欢都市异能、成长热血和高能反转，这部《都市觉醒者》绝对值得加入你的速看清单。",
        ],
      },
    ],
  },
  {
    slug: "douman-sukan-campus",
    title: "《转角遇见你》速看：校园恋爱漫画的正确打开方式",
    category: "sukan",
    excerpt: "一部让人怦然心动的校园恋爱漫画速看解析，看看高冷学霸如何被普通女孩一步步融化。",
    cover: "https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20of%20two%20high%20school%20students%20standing%20under%20cherry%20blossom%20trees%20in%20a%20sunny%20schoolyard%2C%20soft%20warm%20pink%20and%20cream%20tones%2C%20gentle%20pastel%20anime%20art%20style%2C%20sweet%20youthful%20atmosphere%2C%20cinematic%20framing&width=900&height=600&seq=dm-sukan-02&orientation=landscape",
    tags: ["校园恋爱", "速看", "治愈"],
    author: "抖漫编辑部",
    date: "2026-08-10",
    readTime: "3分钟",
    views: "9.8万",
    content: [
      {
        heading: "初见：一场意外的相遇",
        paragraphs: [
          "转学生苏晚初到新班级的第一天，就因一场小意外撞进了全校闻名的学霸陆言怀里，从此开启了这段磕磕绊绊又甜甜的校园日常。",
          "两人从互相看不顺眼，到渐渐发现对方不为人知的温柔一面，校园生活的每个角落都成了他们感情升温的见证。",
        ],
      },
      {
        heading: "成长：恋爱里的双向奔赴",
        paragraphs: [
          "这部漫画最珍贵的地方在于男女主都在互相成就，没有单方面的付出，也没有强行误会。学霸学会放松，女孩变得自信，双向奔赴的爱情让人看得会心一笑。",
          "配角们的友情线同样出彩，让整部作品不止于恋爱，更是一幅青春群像。",
        ],
      },
      {
        heading: "速看总结",
        paragraphs: [
          "如果你最近想找一部轻松治愈、画风又美的校园恋爱漫画，《转角遇见你》几乎不会让你失望，适合在睡前或午休时慢慢享用。",
        ],
      },
    ],
  },
  {
    slug: "douman-jingxuan-swordsman",
    title: "《剑心》精选：一部热血剑客的成长史诗",
    category: "jingxuan",
    excerpt: "编辑强烈推荐的武侠热血漫画，看少年剑客如何从无名之辈成长为守护一方的大侠。",
    cover: "https://readdy.ai/api/search-image?query=Epic%20manga%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20robes%20standing%20on%20a%20misty%20mountain%20cliff%20holding%20a%20glowing%20blade%2C%20dramatic%20warm%20sunset%20backlight%2C%20intense%20determined%20expression%2C%20detailed%20chinese%20wuxia%20fantasy%20anime%20art%2C%20cinematic%20scale&width=900&height=600&seq=dm-jx-swordsman&orientation=landscape",
    tags: ["武侠", "热血", "精选"],
    author: "老林编辑",
    date: "2026-08-09",
    readTime: "5分钟",
    views: "18.2万",
    featured: true,
    content: [
      {
        heading: "推荐理由",
        paragraphs: [
          "《剑心》是一部将中式武侠与漫画热血结合得恰到好处的作品，画风凌厉、打斗分镜极具张力，剧情则层层递进，让人欲罢不能。",
          "主角沈剑心出身无名小村，背负着失传剑法的秘密踏上江湖之路，一路经历背叛、成长与和解。",
        ],
      },
      {
        heading: "角色刻画：有血有肉",
        paragraphs: [
          "作者在角色塑造上下了很大功夫，无论是主角的坚韧，还是反派的挣扎，都并非脸谱化的善恶对立，而是各有立场、各有苦衷。",
          "配角们每个人都有自己的弧光，让整个江湖显得真实而丰满。",
        ],
      },
      {
        heading: "为什么值得入坑",
        paragraphs: [
          "对喜欢武侠热血题材的读者来说，《剑心》兼具爽感与深度，是近两年不可错过的口碑佳作。编辑组内部一致高分推荐。",
        ],
      },
    ],
  },
  {
    slug: "douman-jingxuan-detective",
    title: "《午夜侦探》精选：悬疑推理短篇的巅峰之作",
    category: "jingxuan",
    excerpt: "每一话都是一个完整案件的短篇推理漫画，逻辑严密、反转惊人，推理迷不容错过。",
    cover: "https://readdy.ai/api/search-image?query=Moody%20manga%20illustration%20of%20a%20detective%20silhouetted%20in%20a%20dim%20lamplit%20study%20examining%20case%20files%20on%20a%20desk%2C%20mysterious%20foggy%20midnight%20atmosphere%2C%20warm%20amber%20lamp%20glow%20against%20deep%20shadows%2C%20dramatic%20noir%20anime%20art%20style&width=900&height=600&seq=dm-jx-detective&orientation=landscape",
    tags: ["悬疑", "推理", "精选"],
    author: "老林编辑",
    date: "2026-08-06",
    readTime: "4分钟",
    views: "14.5万",
    content: [
      {
        heading: "单元剧的魅力",
        paragraphs: [
          "《午夜侦探》采用单元剧形式，每一话都是一个完整的小案件，非常适合碎片时间观看，随手翻开一话就能享受推理的乐趣。",
          "但单元剧之间又暗藏一条贯穿全作的主线，当你追到后期会发现所有案件竟然环环相扣。",
        ],
      },
      {
        heading: "严密的推理逻辑",
        paragraphs: [
          "作者在推理逻辑上相当严谨，每个伏笔都有回收，每个反转都有铺垫，很少出现为了反转而反转的生硬剧情。",
          "侦探主角冷静睿智又带点毒舌的性格也极具魅力，与助手搭档之间的互动堪称整部作品的笑点担当。",
        ],
      },
      {
        heading: "编辑点评",
        paragraphs: [
          "如果你喜欢《名侦探柯南》式单元推理又想要更成熟的故事质感，这部《午夜侦探》会是很好的选择，特别适合夜间阅读。",
        ],
      },
    ],
  },
  {
    slug: "douman-pianduan-comedy",
    title: "爆笑名场面合集：让人笑到打鸣的十个片段",
    category: "pianduan",
    excerpt: "精选当下最火的搞笑漫画片段，从社死现场到神仙吐槽，全程高能无尿点。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20comic%20style%20illustration%20of%20multiple%20hilarious%20chaotic%20scenes%20in%20colorful%20panels%2C%20exaggerated%20cartoon%20expressions%2C%20bright%20cheerful%20warm%20palette%2C%20funny%20characters%20slipping%20and%20surprised%20faces%2C%20energetic%20commercial%20anime%20art&width=900&height=600&seq=dm-pd-comedy&orientation=landscape",
    tags: ["搞笑", "名场面", "片段"],
    author: "阿抖",
    date: "2026-08-08",
    readTime: "2分钟",
    views: "22.1万",
    content: [
      {
        heading: "为什么要单看片段",
        paragraphs: [
          "有些漫画的乐趣就藏在某一个神级片段里，与其从头追到尾，不如直接把最精彩的瞬间拎出来看，碎片时间也能笑到停不下来。",
          "本期我们精选了近期最热门的十个搞笑名场面，从社死现场到神仙吐槽，每一帧都是表情包素材。",
        ],
      },
      {
        heading: "本期看点",
        paragraphs: [
          "这里有主角在全校大会上当众摔倒的经典社死瞬间，有宠物和主人斗智斗勇的爆笑日常，还有让人拍案叫绝的犀利吐槽。",
          "每一个片段都经过编辑部严格筛选，保证让你在午休或通勤时笑得前仰后合。",
        ],
      },
    ],
  },
  {
    slug: "douman-pianduan-food",
    title: "深夜慎点！美食漫画五大高能名场面",
    category: "pianduan",
    excerpt: "那些看一次饿一次的美食漫画片段合集，剧情已经不重要了，重要的是这一口到底有多香。",
    cover: "https://readdy.ai/api/search-image?query=Delicious%20gourmet%20manga%20illustration%20of%20steaming%20ramen%20bowl%2C%20sizzling%20skewers%20and%20pastries%20arranged%20on%20a%20wooden%20table%2C%20mouth%20watering%20warm%20appetizing%20glow%2C%20rich%20food%20texture%20detail%2C%20cozy%20shokugeki%20anime%20art%20style&width=900&height=600&seq=dm-pd-food&orientation=landscape",
    tags: ["美食", "名场面", "片段"],
    author: "阿抖",
    date: "2026-08-05",
    readTime: "2分钟",
    views: "19.6万",
    content: [
      {
        heading: "美食漫画的魔力",
        paragraphs: [
          "美食漫画最厉害的地方，是能让你隔着屏幕都闻到香味。从热气腾腾的拉面到外酥里嫩的炸猪排，作者用画笔把「好吃」两个字画得淋漓尽致。",
          "本期我们挑选了五个最让人咽口水的美食名场面，友情提示：请勿在深夜空腹观看。",
        ],
      },
      {
        heading: "高能片段推荐",
        paragraphs: [
          "无论是主角咬下第一口时炸开的满足表情，还是用慢镜头渲染的食材在锅中翻滚的画面，每个片段都堪称视觉盛宴。",
          "看完这些片段，你可能会忍不住想立刻冲进厨房给自己做一顿犒劳自己的好饭。",
        ],
      },
    ],
  },
  {
    slug: "douman-tongqin-office",
    title: "通勤五分钟：给打工人的减压治愈漫画",
    category: "tongqin",
    excerpt: "为通勤路上的打工人量身打造，五分钟一话的减压治愈漫画，让疲惫的早晨多一分轻松。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20relaxing%20manga%20illustration%20of%20a%20tired%20office%20worker%20on%20a%20train%20smiling%20at%20a%20phone%20while%20reading%20comics%2C%20morning%20commute%20scenery%20passing%20by%20window%2C%20soft%20gentle%20morning%20light%2C%20cozy%20relatable%20slice%20of%20life%20anime%20art%2C%20calm%20mood&width=900&height=600&seq=dm-tq-office&orientation=landscape",
    tags: ["通勤", "减压", "治愈"],
    author: "小满",
    date: "2026-08-11",
    readTime: "5分钟",
    views: "8.7万",
    content: [
      {
        heading: "打工人需要一点小确幸",
        paragraphs: [
          "通勤是很多人一天中最累的一段路，挤上地铁、找个角落站稳，如果能有一部轻松的作品陪你度过这段时光，疲惫也会减轻不少。",
          "本期推荐的几部漫画节奏明快、画风治愈，每话都在五分钟左右，刚好覆盖一次单程通勤。",
        ],
      },
      {
        heading: "推荐片单",
        paragraphs: [
          "从记录社畜日常的无厘头喜剧，到讲述普通人互相扶持的温情短篇，这些作品不烧脑、不虐心，只负责在你下车前给你一个好心情。",
          "每天早上打开抖漫，选一部通勤漫画，让好心情从出发那一刻开始。",
        ],
      },
    ],
  },
  {
    slug: "douman-tongqin-subway",
    title: "地铁上也能追的爽漫：节奏明快的入坑指南",
    category: "tongqin",
    excerpt: "适合地铁通勤的爽漫推荐，剧情推进快、随时能停，一次通勤就能刷完一个完整的故事。",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20manga%20illustration%20of%20a%20young%20commuter%20absorbed%20in%20reading%20comics%20on%20a%20subway%20car%2C%20glowing%20panel%20reflections%2C%20energetic%20fast-paced%20mood%2C%20warm%20color%20accents%2C%20modern%20city%20travel%20anime%20art%20style&width=900&height=600&seq=dm-tq-subway&orientation=landscape",
    tags: ["通勤", "爽漫", "推荐"],
    author: "小满",
    date: "2026-08-03",
    readTime: "4分钟",
    views: "7.2万",
    content: [
      {
        heading: "什么漫画适合地铁看",
        paragraphs: [
          "地铁通勤时间有限且常常被打断，适合看的漫画需要具备两个特点：节奏够快、随时能停。",
          "我们整理了一批「地铁友好型」爽漫，它们往往在几话内就抛出足够吸引人的设定和冲突，让你上车就想一直追下去。",
        ],
      },
      {
        heading: "碎片时间的正确用法",
        paragraphs: [
          "与其在地铁上刷着无意义的短视频，不如把通勤时间变成一场漫画冒险。一部好的爽漫，能让原本无聊的路程变得充满期待。",
          "打开抖漫通勤分类，挑一部对味的作品，让每一个通勤日都有一点点不一样。",
        ],
      },
    ],
  },
  {
    slug: "douman-shuiqian-gentle",
    title: "睡前五分钟：温柔治愈系漫画安利",
    category: "shuiqian",
    excerpt: "画风温柔、剧情舒缓的晚安漫画推荐，陪你卸下一天的疲惫，在温暖的故事中安然入睡。",
    cover: "https://readdy.ai/api/search-image?query=Soothing%20dreamy%20manga%20illustration%20of%20a%20cozy%20bedroom%20with%20warm%20fairy%20lights%20and%20a%20sleeping%20cat%20on%20the%20bed%2C%20soft%20pastel%20night%20palette%2C%20tranquil%20comforting%20atmosphere%2C%20gentle%20bedtime%20anime%20art%2C%20peaceful%20mood&width=900&height=600&seq=dm-sq-gentle&orientation=landscape",
    tags: ["睡前", "治愈", "安利"],
    author: "晚风",
    date: "2026-08-13",
    readTime: "5分钟",
    views: "11.3万",
    featured: true,
    content: [
      {
        heading: "睡前不该看的漫画",
        paragraphs: [
          "睡前如果看了太刺激太烧脑的作品，往往越看越清醒，反而不利于入睡。想拥有一个好觉，睡前读物应该温柔、舒缓、充满暖意。",
          "本期推荐的治愈系漫画，画风像是被夕阳镀上了一层柔光，剧情没有激烈冲突，只有生活里的小确幸。",
        ],
      },
      {
        heading: "温柔的故事，安睡的夜晚",
        paragraphs: [
          "有讲述小镇面包店日常的温情短篇，有记录一只猫和一个孤单青年互相治愈的漫画，还有描绘四季更迭、人情冷暖的治愈佳作。",
          "睡前读上五分钟，让这些温柔的故事把你包裹起来，慢慢沉入梦乡。",
        ],
      },
      {
        heading: "给睡眠一个好开始",
        paragraphs: [
          "把手机亮度调低，选一部睡前漫画，让一天的疲惫在暖色调的温柔里慢慢消散。晚安，愿你今夜好眠。",
        ],
      },
    ],
  },
  {
    slug: "douman-shuiqian-starry",
    title: "《星空邮局》睡前短篇：写给远方的一封信",
    category: "shuiqian",
    excerpt: "一个关于星空、思念与告别的温柔睡前短篇，看哭无数读者的治愈神作。",
    cover: "https://readdy.ai/api/search-image?query=Poetic%20manga%20illustration%20of%20a%20small%20figure%20on%20a%20hill%20writing%20a%20letter%20under%20a%20vast%20starry%20night%20sky%20with%20a%20glowing%20moon%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20whimsical%20dreamy%20atmosphere%2C%20emotional%20tender%20anime%20art%20style&width=900&height=600&seq=dm-sq-starry&orientation=landscape",
    tags: ["睡前", "短篇", "治愈"],
    author: "晚风",
    date: "2026-08-01",
    readTime: "4分钟",
    views: "16.4万",
    content: [
      {
        heading: "故事梗概",
        paragraphs: [
          "在世界的某个角落，有一家只在深夜营业的星空邮局。据说在这里寄出的信，会被送到无法再见的人手中。",
          "女孩小夏带着对已故祖母的思念来到这里，写下了一封迟到了十年的信，而邮局里神秘的老店主，则开始讲述他守候多年的故事。",
        ],
      },
      {
        heading: "为什么值得一读",
        paragraphs: [
          "这部短篇最动人的地方，是把「告别」和「思念」画得格外温柔。它不煽情、不催泪，却能在某个安静的瞬间击中你心里最柔软的地方。",
          "画风如同静谧的星空，故事简单却余味悠长，非常适合作为睡前读物，带着一份温暖进入梦乡。",
        ],
      },
    ],
  },
  {
    slug: "douman-richang-cat",
    title: "《养猫日常》：一个人的深夜不再孤单",
    category: "richang",
    excerpt: "记录一个独居青年和一只橘猫的治愈日常，平淡生活里的小确幸，看了就停不下来。",
    cover: "https://readdy.ai/api/search-image?query=Cute%20heartwarming%20manga%20illustration%20of%20an%20orange%20tabby%20cat%20and%20a%20young%20person%20relaxing%20together%20at%20home%20in%20the%20evening%2C%20warm%20cozy%20living%20room%2C%20soft%20lamp%20light%2C%20playful%20gentle%20slice%20of%20life%20anime%20art%2C%20adorable%20and%20calming&width=900&height=600&seq=dm-rc-cat&orientation=landscape",
    tags: ["猫咪", "日常", "治愈"],
    author: "大橘",
    date: "2026-08-07",
    readTime: "3分钟",
    views: "13.9万",
    content: [
      {
        heading: "一猫一人的日常",
        paragraphs: [
          "《养猫日常》讲述独居青年阿铭和一只名叫「大橘」的橘猫之间的点点滴滴。没有惊天动地的剧情，只有吃饭、睡觉、被猫踩奶的琐碎日常。",
          "正是这些看似平淡的瞬间，却被作者画得格外温暖治愈，让无数同样独居的读者找到共鸣。",
        ],
      },
      {
        heading: "被猫治愈的瞬间",
        paragraphs: [
          "加班回家开门时猫在玄关迎接的瞬间，晚上窝在沙发上看电视时猫钻进怀里的瞬间，这些细节被作者细腻地捕捉并画进故事里。",
          "如果你也养猫，或是渴望有一只毛茸茸的陪伴，这部漫画会让你会心一笑，也让你更加珍惜身边的温暖。",
        ],
      },
    ],
  },
  {
    slug: "douman-richang-martial",
    title: "《武道学院》日常：热血青春的宿舍生活",
    category: "richang",
    excerpt: "除了修炼与对决，武道学院里也有满满的日常笑料，看看这群热血少年不打坐时都在干什么。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20manga%20illustration%20of%20martial%20arts%20academy%20students%20joking%20around%20in%20a%20lively%20dormitory%2C%20training%20gear%20and%20snacks%20scattered%2C%20dynamic%20warm%20sunny%20scene%2C%20fun%20youthful%20energy%2C%20modern%20shonen%20anime%20art%20style&width=900&height=600&seq=dm-rc-martial&orientation=landscape",
    tags: ["青春", "热血", "日常"],
    author: "大橘",
    date: "2026-07-28",
    readTime: "4分钟",
    views: "10.1万",
    content: [
      {
        heading: "修炼之外的日常",
        paragraphs: [
          "《武道学院》虽然主打热血修炼与学院对决，但作者同样擅长刻画角色的日常，让这群少年在切磋之外也有满满的生活气息。",
          "抢食堂的最后一盘红烧肉、熄灯后的卧谈会、训练场上互相较劲又互相扶持，这些日常片段让角色更加鲜活立体。",
        ],
      },
      {
        heading: "热血的另一种样子",
        paragraphs: [
          "真正的热血不只是打斗，更是少年们为了同一个目标一起努力的样子。武道学院的日常，把这种热血诠释得恰到好处。",
          "看他们在宿舍里打打闹闹，又在赛场上并肩作战，这种反差正是这部作品最迷人的地方。",
        ],
      },
    ],
  },
];